import type React from "react";

/**
 * Career Success Stories source data, transcribed from the "Miles Alumni
 * Testimonial" sheet: rows 1-80 (up to Aayush Gupta), with the red-highlighted
 * duplicate rows (#16, #22, #59, #60, #62) omitted.
 *
 * Rows without a YouTube link are not carried over, since the reel has no
 * video to play.
 *
 * Three separate images per alumnus, all from the miles_website/alumni-data
 * ImageKit folder:
 *   - `thumbnail`    - the video still used by the story cards
 *   - `videoPoster`  - the portrait frame the reel shows before playback and
 *                      while paused, in place of the iframe
 *   - `profilePic`   - the headshot shown as the reel's caption avatar on
 *                      both desktop and mobile
 *
 * "CPA + CMA" is deliberate: normaliseCourses() splits on "+", so those
 * entries match both the CPA and CMA pills and the badge renders both.
 */
export const alumniStories = [
  {
    name: "Akhil",
    course: "CPA",
    company: "Big 4",
    city: "",
    content:
      "CPA helped me take the next step in my career and get into a Big 4. In order to grow you need to have a qualification and once you get that, you will be followed with a lot of respect and high paying salaried jobs. Having AI intergrated into our jobs makes our career easier in the future.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Akhil_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Akhil_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Akhil.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=GUh-fEHW2c0&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=13",
  },
  {
    name: "Disha S",
    course: "CMA",
    company: "MCC",
    city: "",
    content:
      "Miles Education has indeed cracked the code by helping us focus on ourselves and our careers. CMA gave me international exposure and helped me become more confident in my career. The AI tools that were taught in the CAIRA session were indeed very helpful.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Disha_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Disha_S_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Disha.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=mbA3wa3GYr0&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=15",
  },
  {
    name: "Arvind",
    course: "CMA",
    company: "RRD",
    city: "kochi",
    content:
      "Completing my CMA helped me land my first job with a good package almost immediately. I am really very excited to start my career after completing CMA with Miles. Miles has also introduced CAIRA which is very great and you can get to learn a lot of new things about AI.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arvind_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arvind_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arvind.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=KIoMcS4jG3I&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=9",
  },
  {
    name: "Mehak Khan",
    course: "CMA",
    company: "CFO, IQue Ventures",
    city: "Bengaluru",
    content:
      "My CMA helped me stand out and gave me the confidence to grow into a CFO role. I could clear both the parts of my CMA in the first attempt with the help of Miles and i am very happy and proud of myself. Varun sirs videos were of great help and made me understand the concepts really well.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Mehak_Khan_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Mehak_Khan_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Mehak%20Khan.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=GWKwKaKXMlg&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=25",
  },
  {
    name: "Pallavi",
    course: "CPA",
    company: "Preston Security",
    city: "",
    content:
      "After completing my CPA, I feel more confident and feel like I can take on anything and i feel like i have my future set for another 40 years. CAIRA is going to be really helpful cause we are at a stage where everyone is upskilling, so CAIRA is going to definitely help us with that.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Pallavi_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Pallavi_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Pallavi.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=e_LK6trXtWg&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=14",
  },
  {
    name: "Arushi",
    course: "CMA",
    company: "",
    city: "",
    content:
      "My CMA helped me stand out, and pursuing CPA is helping me take that advantage even further. Even i stepped into Miles, the faculty and everyone around were very welcoming and helpful. Varun Jain sirs videos were also very helpful and fun as well.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arushi_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arushi_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arushi.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=M6Vp8XrPHPA&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=12",
  },
  {
    name: "Akshatha",
    course: "CMA",
    company: "",
    city: "",
    content:
      "Completing my CMA helped me groom my personality and made people see me with more respect because i have earned a professional certificate from Miles. Miles Placement Team helped me a lot from the start to the end of my CMA journey.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Akshatha_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Akshatha_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Akshatha.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=qeAjJ9J8LJE&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=10",
  },
  {
    name: "Renuka",
    course: "CMA",
    company: "",
    city: "",
    content:
      "My journey with Miles helped me build more confidence and take a stronger step forward in my career. After completing my CMA, it has given me a sense of professionalism so i am sure i'll make the most out of it. Miles has made it very easy by the way they have designed the entire resources and by revisiting Varun sirs videos.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Renuka_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Renuka_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Renuka.png",
    youtubeLink: "https://www.youtube.com/watch?v=kWQ5y8HvQVo",
  },
  {
    name: "Deepthi AR",
    course: "CMA",
    company: "ISP — FP&A",
    city: "Bengaluru",
    content:
      "CMA gave my profile the edge I needed, and Miles' LMS helped me prepare for the real exam. Writing the online LMS mock exams is what really helped us excel in the exam. The CAIRA workshop was really helpful for our careers as well.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Deepthi_AR_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Deepthi_AR_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Deepthi%20AR.png",
    youtubeLink: "https://www.youtube.com/watch?v=lOKmrLp2eN0",
  },
  {
    name: "Shahid",
    course: "CPA",
    company: "State Street Corporation",
    city: "",
    content:
      "CPA helped me boost my career and get the recognition I was looking for. The whole journey was really exciting. Miles is the best institute to learn CPA and CMA in India. I am very excited to grow and learn with AI because AI is not going to take away the job but instead remove monotonous repetitve tasks.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shahid_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shahid_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shahid.png",
    youtubeLink: "https://www.youtube.com/watch?v=I5HttPdBe_k",
  },
  {
    name: "Anushka",
    course: "CMA",
    company: "BlackRock",
    city: "",
    content:
      "CMA gave me an edge in my profile and helped me apply what I learned directly to my role. Miles has been very welcoming and it has been a great experience so far. CMA is not limited to a specific job and it is going to help us in any career we want to pursue. I able to apply skills that i have learnt from my CMA.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anushka_Thumbnail_Video.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anushka_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anushka.png",
    youtubeLink: "https://www.youtube.com/watch?v=srWba78X62w",
  },
  {
    name: "Arshiya Ratnam",
    course: "CPA + CMA",
    company: "",
    city: "",
    content:
      "CPA opened up a world of opportunities for me, and now I'm looking to upskill further with AI. All my credits towards Miles, Varun Jain sir and the faculty present there to help me out in anything and everything and also helped me pursue both my CPA and CMA.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arshiya_Ratnam_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arshiya_Ratnam_thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arshiya%20Ratnam.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=IMFPIOfZKCQ&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=2",
  },
  {
    name: "Vinay Mittal",
    course: "CPA + CMA",
    company: "",
    city: "",
    content:
      "Getting CPA changed my life and gave me the confidence to aim higher in my career. Right now i'm living my dream life that i was dreaming about 5 years ago. I wouldn't be here if it wasn't for miles. The recorded videos and their management is the best.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vinay_Mittal_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vinay_Mittal_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vinay%20Mittal.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=Ms2uykxJSP4&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=4",
  },
  {
    name: "Priyansh Bhardwaj",
    course: "CPA",
    company: "EY — Assurance",
    city: "Hyderabad",
    content:
      "Becoming a CPA boosted my confidence and changed how I look at my career and work.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Priyansh_Bhardwaj_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Priyansh_Bhardwaj_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Priyansh%20Bhardwaj.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=LJFqgz9mj14&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=3",
  },
  {
    name: "Ramya Murlidharan",
    course: "CMA",
    company: "",
    city: "Bengaluru",
    content:
      "Balanced family and studies, using Miles' LMS and classes to complete CMA successfully. The LMS, classes by Varun sir and the recorded sessions were really helpful for me. The MCQs connected the concepts to the actual lessons taught and explained which made the journey really easy and the reason for me to complete it.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Ramya_Murlidharan_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Ramya_Murlidharan_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Ramya%20Murlidharan.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=g2UePbBVw5c&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=23",
  },
  // {
  //   name: "Calvisha",
  //   course: "CPA",
  //   company: "HPE",
  //   city: "Bengaluru",
  //   content:
  //     "Got placed at HPE through Miles and believes CAIRA broadened her perspective on AI.",
  //   thumbnail:
  //     "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Calvisha_video_Thumbnail.png",
  //   videoPoster:
  //     "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Calvisha_Thumbnail.png",
  //   profilePic:
  //     "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Calvisha.png",
  //   youtubeLink:
  //     "https://www.youtube.com/watch?v=OEbD9yOxDxw&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=207",
  // },
  {
    name: "Rudraksh Bajaj",
    course: "CPA",
    company: "HPE",
    city: "Delhi",
    content:
      "I believes modern CPAs must understand AI and CAIRA is an essential skill builder. CPA was one of the fastest ways to achieve a professional degree. Going through a lot of MCQs, simulations and recorded videos will really help in the exam..",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Rudraksh_Bajaj_thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Rudraksh_Bajaj_video_thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Rudraksh%20Bajaj.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=OEbD9yOxDxw&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=207",
  },
  {
    name: "Anushka Jain",
    course: "CPA",
    company: "",
    city: "",
    content:
      "For me, CPA is no longer just about numbers. With Miles and CAIRA, I got to combine finance, technology, and AI skills that are helping me stay ready for the future of work.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anushka_Jain_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anushka_Jain_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anushka%20Jain.png",
    youtubeLink: "https://youtu.be/0_Gxxgb2tHY?si=c3lZc5CJgZndKfN-",
  },
  {
    name: "Anjela Moni",
    course: "CPA",
    company: "",
    city: "",
    content:
      "My journey with Miles was about much more than academics. It helped me build confidence, embrace new opportunities, and grow both personally and professionally with every step.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anjela_Moni_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anjela_Moni_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anjela%20Moni.png",
    youtubeLink: "https://youtu.be/nlTNP3fmTJ0?si=hHdQV3kPyd2VPpy6",
  },
  {
    name: "Pallavi",
    course: "CPA",
    company: "",
    city: "",
    content:
      "After doing CPA, I feel like I can do anything now. It changed my confidence completely, opened my mind to global opportunities, and showed me why continuous learning and adapting to AI is so important in accounting today.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Pallavi_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Pallavi_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Pallavi.png",
    youtubeLink: "https://youtu.be/e_LK6trXtWg?si=u3AFEASukQAvss3p",
  },
  {
    name: "Naveen Kumar",
    course: "CPA",
    company: "",
    city: "",
    content:
      "People at my office approach me because they know I pursued CPA and Miles made that possible.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Naveen_Kumar_Video_Thumbnail..png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/naveen_kumar_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Naveen%20Kumar.png",
    youtubeLink: "https://youtube.com/shorts/bFldpplO-Qw?si=-H9vR74l7UWUhEFK",
  },
  {
    name: "Sharavani kaml prasad",
    course: "CPA",
    company: "",
    city: "Bengaluru",
    content:
      "After clearing CPA, I finally have the confidence that I truly know the subject, and I know this will help me stand out in the future\n(or) \nThe mentors at Miles supported me throughout my entire CPA journey, and the mnemonics in the textbooks were extremely handy during the exams.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sharavani_Kaml_Prasad_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sharavani_Kaml_Prasad_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sharavani%20Kaml%20Prasad.png",
    youtubeLink: "https://youtube.com/shorts/8qjRzin9lVQ?si=Pm_RLL4lEnWDatG4",
  },
  {
    name: "Arjun Mangalath Prasad",
    course: "CMA",
    company: "",
    city: "Bengaluru",
    content:
      "The videos helped me focus on the key areas that really matter for the exam, so my preparation stayed very targeted.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arjun_Mangalath_Prasad_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arjun_Mangalath_Prasad_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Arjun%20Mangalath%20Prasad.png",
    youtubeLink: "https://youtube.com/shorts/D6LxS6fyfso?si=ESBtiGuM6AdFL5ez",
  },
  {
    name: "Shantanu Tantry",
    course: "CPA",
    company: "",
    city: "Bengaluru",
    content:
      "The LMS, videos, and classes really helped me prepare for the CPA exam in a structured and stress-free way.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shantanu_Tantry_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shantanu_Tantry_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shantanu%20Tantry.png",
    youtubeLink: "https://youtube.com/shorts/5Ywsf_uI8ds?si=I2Tu0t5v3b_Fki2E",
  },
  {
    name: "Deep Mukherjee",
    course: "CPA",
    company: "",
    city: "Bengaluru",
    content:
      "I found the MILES material very compact and to the point , everything was explained clearly without unnecessary overload.\nVarun sir’s energy really stands out it keeps you motivated and that energy genuinely transfers to you while learning",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Deep_Mukherjee_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Deep_Mukherjee_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Deep%20Mukherjee.png",
    youtubeLink: "https://youtube.com/shorts/d99A0lqwp5I?si=b2wvwpFEKaToTj5b",
  },
  {
    name: "Vishakha Lahoti",
    course: "CMA",
    company: "",
    city: "Bengaluru",
    content:
      "After completing CMA, I genuinely feel there’s a difference  both in how companies see me and even among my college peers.\n\nWith Miles, the entire journey became much easier — I was able to clear both parts of CMA within just six to seven months",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vishakha_Lahoti_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vishakha_Lahoti_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vishakha%20Lahoti.png",
    youtubeLink: "https://youtube.com/shorts/ajG08FQPwCw?si=M47aEZaSabTrvBHd",
  },
  {
    name: "Aleena Joe",
    course: "CMA",
    company: "",
    city: "",
    content:
      "The HOP materials and MCQs on the LMS helped me push my limits and build strong concepts.” he mnemonics in the videos made it easier to remember key points.”",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Aleena_Joe_Video_thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Aleena_Joe_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Aleena%20Joe.png",
    youtubeLink: "https://youtube.com/shorts/yaOwnOTmygk?si=2p05-vI27BQoNkWi",
  },
  {
    name: "Soundarya Shivani",
    course: "CMA",
    company: "",
    city: "",
    content:
      "Miles gave me access to everything I needed — study material, resources, LMS, videos, MCQs, and even one-on-one faculty sessions to clear my doubts\nFor me, Miles was a one-stop solution that supported me from start to finish.”",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Soundarya_Shivani_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Soundarya_Shivani_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Soundarya%20Shivani.png",
    youtubeLink: "https://youtube.com/shorts/ZHrh7COTQKw?si=pej_U8G4pP3Hkx0W",
  },
  {
    name: "Deepika D Bhatt",
    course: "CMA",
    company: "",
    city: "Bengaluru",
    content:
      "One day, you’ll genuinely be happy that you chose MILES and that you chose US CMA I can say that from my own experience.”",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Deepika_D_Bhatt_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Deepika_D_Bhatt_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Deepika%20D%20Bhatt.png",
    youtubeLink: "https://youtube.com/shorts/emRhPTLZS1U?si=f4ecA1ScrYS-t2VH",
  },
  {
    name: "Nitin Dhall",
    course: "CMA",
    company: "",
    city: "Bengaluru",
    content:
      "What really stood out to me about Varun sir is the contribution he’s making to the finance community, it genuinely feels like he’s creating opportunities for us, not just running a business",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nitin_Dhall_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nitin_Dhall_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nitin%20Dhall.png",
    youtubeLink: "https://youtube.com/shorts/UFrKfJ44YY4?si=dRkFVND64lzb7h3m",
  },
  {
    name: "Neha P Deshmukh",
    course: "CMA",
    company: "",
    city: "Bengaluru",
    content:
      "I was never confident and always struggled my way through it and i found the course challenging but Miles really supported me through my journey and helped me build confidence. People surrounding me also looked at me with a different type of value and i had a sense of pride. Miles exceptionally transformed me to become a better person.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Neha_P_Deshmukh_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Neha_P_Deshmukh_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Neha%20P%20Deshmukh.png",
    youtubeLink: "https://youtube.com/shorts/aZ2WpYsIcNg?si=8rgfANQFPJurSIG7",
  },
  {
    name: "Hrithika Balla",
    course: "CMA",
    company: "",
    city: "Bengaluru",
    content:
      "AI isn’t a trend anymore - it’s reshaping how companies evaluate talent, skills, and readiness for tomorrow.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Hrithika_Balla_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Hrithika_Balla_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Hrithika%20Balla.png",
    youtubeLink: "https://youtube.com/shorts/fA-hh81NHLw?si=EraU8gvb_PxzIAUp",
  },
  {
    name: "Sandhya Shree",
    course: "CPA",
    company: "Miles Education",
    city: "Bengaluru",
    content:
      "You know how CPA changed my life? The day when I came into Miles, I was just a student. Now it became an alumini. Now I'm working as a academics associate. I thoroughly followed Miles LMS and the E - books. I'm now working as a lecturer at Miles itslef fulfilling my dreams as a CPA aspirant.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sandhya_Shree_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sandhya_Shree_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sandhya%20Shree.png",
    youtubeLink: "https://youtube.com/shorts/YGF_zZbM_uE?si=xRrAzzI7iHILnmwn",
  },
  {
    name: "Manoj",
    course: "CPA",
    company: "KPMG",
    city: "Bengaluru",
    content:
      "Being placed at a big four as a first job offer was great thing to me which was given to me by miles for which I am very much grateful.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Manoj_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Manoj_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Manoj.png",
    youtubeLink: "https://youtu.be/VIl2r5wLFSU?si=vn9AwCf7BInIuSUR",
  },
  {
    name: "Jemish Thummar",
    course: "CPA",
    company: "",
    city: "Surat",
    content:
      "Miles has helped me a lot in my journey and the materials are very to the topic. Varun jain's teaching style is exceptional.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Jemish_Thummar_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Jemish_Thummar_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Jemish%20Thummar.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=nhgKPD6f--I&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=38",
  },
  {
    name: "Aditya",
    course: "CMA",
    company: "FNAP Domain",
    city: "",
    content:
      "AI has taken it's first step into the market. We need to adapt to it quickly as it'll take over many things and CAIRA will play a big role in this.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Aditya_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Aditya_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Aditya.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=pFJ3VbfqqHs&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=34",
  },
  {
    name: "Divya Bafna",
    course: "CMA",
    company: "EXL",
    city: "Karnataka",
    content:
      "AI + CAIRA in one's resume brings a lot of weightage & a step closer to corporate. It helps in saving a lot of time.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Divya_Bafna_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Divya_Bafna_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Divya%20Bafna.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=1K-7Jae6QiE&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=35",
  },
  {
    name: "Karthik",
    course: "CMA",
    company: "",
    city: "",
    content:
      "Miles has really helped me, Varun Jain's masterclasses and learning AI is like the cherry on the top. Attended CAIRA Level - 1.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Karthik_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Karthik_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Karthik.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=OkM4-EFIdyM&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=14",
  },
  {
    name: "Ashin Ariyakkara",
    course: "CMA",
    company: "HC Global Business Solutions",
    city: "",
    content:
      "Really happy that Miles helped me to crack the code. Helped me to grow and build my confidence into this field.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Ashin_Ariyakkara_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Ashin_Ariyakkara_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Ashin%20Ariyakkara.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=lIA6tXEPXgw&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=47",
  },
  {
    name: "Jyoti Asrani",
    course: "CPA",
    company: "Amazon",
    city: "",
    content:
      "The way Miles has structed this course is so good that I could manage my studies along with my full-time job. Mocks were helpful & all teachers very approachable.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Jyoti_Asrani_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Jyoti_Asrani_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Jyoti%20Asrani.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=fo01ovjC9Hw&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=48",
  },
  {
    name: "Gopika Lakshmi V",
    course: "CMA",
    company: "",
    city: "Kerala",
    content:
      "Tutors and mentors were the best, recorded classes helped me in my conceptual clarity, mock practices helped me a lot in my preparation journey.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Gopika_Lakshmi_V_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Gopika_Lakshmi_V_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Gopika%20Lakshmi%20V.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=czQso56ZqXs&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=45",
  },
  {
    name: "Abhay Yadav",
    course: "CMA",
    company: "",
    city: "",
    content:
      "They were really supportive and their guidance through my prep was great.\nVarun Sir's conceptual teachings through videos was great.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Abhay_Yadav_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Abhay_Yadav_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Abhay%20Yadav.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=Ecq59Iv8kJc&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=46&pp=iAQBsAgC",
  },
  {
    name: "Srinath Ramesh",
    course: "CPA",
    company: "",
    city: "Chennai",
    content:
      "They really had a structured approach, Varun Jain's sessions were really helpful, the mock tests helped me a lot. The books were very structured and easy to understand",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Srinath_Ramesh_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Srinath_Ramesh_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Srinath%20Ramesh.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=thDq1j2yh2o&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=45&pp=iAQB0gcJCRMMAYcqIYzvsAgC",
  },
  {
    name: "Nital Shah",
    course: "CPA",
    company: "",
    city: "",
    content:
      "Team has been very cooperative and polite. They give answers directly and not beat around the bush. We don't have to go and refer anywhere else. They give you a personalised study routine.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nital_Shah_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nital_Shah_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nital%20Shah.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=2kHkC4cmEZs&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=44&pp=iAQBsAgC",
  },
  {
    name: "Chirag Shah",
    course: "CMA",
    company: "XLR Global",
    city: "Pune",
    content:
      "The Miles LMS system is the best, MCQs were the most helpful. Mini mock tests helped me a lot during my preparations.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Chirag_Shah_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Chirag_Shah_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Chirag%20Shah.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=4qWR_sZCGNI&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=43&pp=iAQBsAgC",
  },
  {
    name: "Govind",
    course: "CMA",
    company: "",
    city: "Punjab",
    content:
      "The mentors and the mentoring hours were really helpful. LMS was really elaborAtive and structured. The mentors was very punctual, they also solved my doubts in the best possible way.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Govind_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Govind_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Govind.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=73V1mgfeAPM&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=42&pp=iAQBsAgC",
  },
  {
    name: "Puja Ashutosh Maheshwari",
    course: "CPA",
    company: "AP Associates",
    city: "Dubai",
    content:
      "Really liked the way study materials has been designed, easy to understand and replicate in the exam as well. Needed CPA to grow bigger.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Puja_Ashutosh_Maheshwari_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Puja_Ashutosh_Maheshwari_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Puja%20Ashutosh%20Maheshwari.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=D1JZLmLDBrw&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=41&pp=iAQBsAgC",
  },
  {
    name: "Vishakha Hemant Raje",
    course: "CPA",
    company: "",
    city: "",
    content:
      "Material and LMS is excellent. If i did not understand a particular topic, i used to go back to the recorded session and practice them.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vishakha_Hemant_Raje_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vishakha_Hemant_Raje_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vishakha%20Hemant%20Raje.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=8k_67l1SH_A&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=40&pp=iAQBsAgC",
  },
  {
    name: "Niharika BK",
    course: "CMA",
    company: "",
    city: "Bangalore",
    content:
      "AI is here but it is up to us humans to keep evolving ourselves and adapt AI into our day to day lives. Monotonous tasks can be removed by using AI's help.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Niharika_BK_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Niharika%20_BK_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Niharika%20BK.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=4jKJ6fzN4Bo&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=34&pp=iAQBsAgC",
  },
  {
    name: "Monisha",
    course: "CMA",
    company: "",
    city: "Bangalore",
    content:
      "CAIRA is helping us effectively and it is saving our time. AI is helping Finance in a really positive way, removes all the basic level work",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Monisha_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Monisha_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Monisha.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=9J-LyjMV4tw&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=33&pp=iAQBsAgC",
  },
  {
    name: "Khushi Mishra",
    course: "CAIRA",
    company: "",
    city: "Bangalore",
    content:
      "AI is another big technology that is gonna help us in everything we do. It can help build leverage. We get assignments related to finance and accountancy and we use AI for them and it is going to make us industry ready.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Khushi_Mishra_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Khushi_Mishra_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Khushi%20Mishra.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=vM03MCXGVe4&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=32&pp=iAQBsAgC",
  },
  {
    name: "Shravya M",
    course: "CAIRA",
    company: "",
    city: "",
    content:
      "We are taking over AI, ones who know about AI will cherish in future.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shravya_M_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shravya_M_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shravya%20M.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=FQzIm8nAOAA&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=25&pp=iAQBsAgC",
  },
  {
    name: "Sandra Silvester",
    course: "CMA",
    company: "",
    city: "",
    content:
      "CMA is a good course and it takes a short span of time to complete. It gives good exposure and helps enhance our proflie. Varun sir's offline sessions really helped me a lot.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sandra_Silvester_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sandra_Silvester_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sandra%20Silvester.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=nr6WyvvHNVc&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=11",
  },
  {
    name: "Anurag Kumar",
    course: "CMA",
    company: "",
    city: "",
    content:
      "Varun Sir's video gave me the confidence to pursue this decision of mine. What have I learnt is, AI shouldn't be our competitor, but helps us by standing beside  and in our job too. Miles integrating AI into it's courses is really helpful for all aspirants to be updated and more effective in this field.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anurag_Kumar_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anurag_Kumar_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anurag%20Kumar.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=Nkx5MzEdLWg&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=6",
  },
  {
    name: "Neshvi Shah",
    course: "CPA",
    company: "",
    city: "Mumbai",
    content:
      "I am seeing the biggest change in my life and i have started setting targets to achieve. My overall journey with miles was wonderful. Solving mock tests helped in concept clarity and time pressure.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Neshvi_Shah_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Neshvi_Shah_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Neshvi%20Shah.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=qH7bv3MVkqk&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=52&pp=iAQBsAgC",
  },
  {
    name: "Bikash Sah",
    course: "CPA",
    company: "GMD",
    city: "Delhi",
    content:
      "I liked the Miles ecosystem and my journey was very smooth. They helped me out with my education and bridge course as well. The LMS is very interactive, there were no lags and very smooth to run. The study materials were also very precise. The software that Miles used for it's examinations was almost the same which was being used in the real examination.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Bikash_Sah_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Bikash_Sah_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Bikash%20Sah.png",
    youtubeLink:
      "https://www.youtube.com/watch?v=3TY0IxAj74I&list=PLf9NGcR_ulpUfHHpW0zik7CjtlE66XbMj&index=53",
  },
  {
    name: "Diya Kothari",
    course: "CMA",
    company: "",
    city: "Ahmedabad",
    content:
      "People give more importance and value you only if you have a certification. Miles is having an amazing LMS with mock exams and MCQs. Even the mentoring sessions i had at the end were very helpful.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Diya_Kothari_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Diya_Kothari_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Diya%20Kothari.png",
    youtubeLink: "https://youtu.be/cv_SalB1cG0?si=-_BUwSM1S-QVKtpo",
  },
  {
    name: "Garima Naveen",
    course: "CPA",
    company: "",
    city: "Haryana",
    content:
      "CMA and CPA both gave me really good confidence to earn a globally recognised certification. It was a wonderful journey with miles and the study material was very sufficient.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Garima_Naveen_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Garima_Naveen_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Garima%20Naveen.png",
    youtubeLink: "https://youtu.be/4qBRqW9tQ_g?si=hzwqlEAwcmwn5Q4Y",
  },
  {
    name: "Himanshu Assudani",
    course: "CPA",
    company: "Ultra Tech Cement",
    city: "Rajasthan",
    content:
      "Having a CPA gives a different perspective to the society as well and more oppourtunities are approched. I was very impressed by the session Varun sir took.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Himanshu_Assudani_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Himanshu_Assudani_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Himanshu%20Assudani.png",
    youtubeLink: "https://youtu.be/UExFwq0YShc?si=u47v0s0ZWqRgtMF_",
  },
  {
    name: "Mayank Singh",
    course: "CPA",
    company: "",
    city: "Mumbai",
    content:
      "The material i received from miles were very great and Varun sir's videos were helpful. LMS is the best thing because you can do it 24/7.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Mayank_Singh_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Mayank_Singh_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Mayank%20Singh.png",
    youtubeLink: "https://youtu.be/EgDlxtb4-sQ?si=4G9rN1GwI2ApNrO4",
  },
  {
    name: "Nemani Sri Sai Saran",
    course: "CPA",
    company: "",
    city: "Pondicherry",
    content:
      "The LMS helped me a lot because i had no clue how the questions will be asked in the exam. Miles gave an entire overview of the SIMS and MCQs of how it will be in the exam and their material is very interesting.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nemani_Sri_Sai_Saran_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nemani_Sri_Sai_Saran_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nemani%20Sri%20Sai%20Saran.png",
    youtubeLink: "https://youtu.be/9hqKR_4SxqU?si=O29BSn52-xoDsp15",
  },
  {
    name: "Dipankar Mondal",
    course: "CPA",
    company: "",
    city: "Kolkata",
    content:
      "CPA is the strongest credential in the world, it definitely helped me and will help me in the future as well. Going through all Varun sirs lectures, LMS, MCQs, simulations, it gave me a lot of confidence.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Dipankar_Mondal_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Dipankar_Mondal_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Dipankar%20Mondal.png",
    youtubeLink: "https://youtu.be/gFi7CPaFJUE?si=LIeDl_iyUESqTD9o",
  },
  {
    name: "Saudamini Eppili",
    course: "CMA",
    company: "BDO India LLP",
    city: "",
    content:
      "Best thing about Miles that i found out are the live sessions which are really interactive. Varun sirs lectures are enough if a person does not have enough time and was really helpful.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Saudamini_Eppili_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Saudamini_Eppili_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Saudamini%20Eppili.png",
    youtubeLink: "https://youtu.be/aboAI9BSvxw?si=fxGm_R_K35-_R9qV",
  },
  {
    name: "S K Sameer",
    course: "CPA",
    company: "KPMG",
    city: "Kolkata",
    content:
      "After I have done my CPA i'm very confident with the work i do and how stuff works in the real world. My overall journey has been great as i've been getting full support",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/S_K_Sameer_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/S_K_Sameer_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/S%20K%20Sameer.png",
    youtubeLink: "https://youtu.be/7L3iCPU2gbs?si=3NQ7SlKDYDbzkdeh",
  },
  {
    name: "Tessa Santosh",
    course: "CPA",
    company: "",
    city: "Kerala",
    content:
      "Having a CPA sets me apart and an edge over most of the people from getting jobs. My overall experience with Miles has been great and have been very supportive. They even helped me with placements after the course was done.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Tessa_Santosh_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Tessa_Santosh_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Tessa%20Santosh.png",
    youtubeLink: "https://youtu.be/EdrYBnXYfbU?si=geDF3B0P7rnlHzvi",
  },
  {
    name: "Kalgi Mistry",
    course: "CPA",
    company: "",
    city: "Ahmedabad",
    content:
      "Miles is the best coaching institute which provides CPA and CMA career upfront. Varun sirs videos provide a conceptual clarity. It is very easy to read and understand.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Kalgi_Mistry_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Kalgi_Mistry_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Kalgi%20Mistry.png",
    youtubeLink: "https://youtu.be/6_1ucCmG6Wc?si=OQWZiihPnjKW05sv",
  },
  {
    name: "Pratik Soni",
    course: "CPA",
    company: "KPMG",
    city: "Bangalore",
    content:
      "After i did my CPA, I saw a lot of changes and instantly felt more confident. It has been great from the first day. LMS access was great along with the MCQs and is quite user friendly. Miles has been a saviour to be very honest.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Pratik_Soni_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Pratik_Soni_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Pratik%20Soni.png",
    youtubeLink: "https://youtu.be/7paRuRkix5Q?si=lxTkiBvLNe1aMF8X",
  },
  {
    name: "Bhoomi",
    course: "CMA",
    company: "",
    city: "Mumbai",
    content:
      "Everyone has been praising me and i have been confident and my knowledge has increased. I'm very proud of myself to finish CMA before my graduation. My journey with miles was really smooth and was enjoyable to learn with miles. the LMS is superb.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Bhoomi_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Bhoomi_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Bhoomi.png",
    youtubeLink: "https://youtu.be/zUadV3ex7y4?si=NHlkzLyl4JVe7jsW",
  },
  {
    // The sheet name and both ImageKit filenames carry a trailing space, which
    // survives in the URLs as %20 - do not "tidy" it or the images 404.
    name: "Chirag",
    course: "CMA",
    company: "SAX Advisory Group",
    city: "",
    content:
      "My confidence level has greatly increased. Now when i walk into a room, everyone knows im a CMA and give me that value. My overall journey with Miles has been really great and helped me throughout. Their LMS has been the best part.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Chirag%20_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Chirag_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Chirag%20.png",
    youtubeLink: "https://youtu.be/LJvhwOaWQBw?si=uTwm2wc2lq_9dNTY",
  },
  {
    name: "Vishal Sharma",
    course: "CPA",
    company: "KPMG",
    city: "Kochi",
    content:
      "Having a CPA degree counts in the real world and is in demand and it has changed my personality. Miles Placement Team has really helped me a lot and the LMS was really helpful throughout my journey.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vishal_Sharma_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vishal_Sharma_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vishal%20Sharma.png",
    youtubeLink: "https://youtu.be/cWu8wvtcixo?si=D6N8OprWZqHFBcg6",
  },
  {
    name: "Aayush Gupta",
    course: "CPA",
    company: "",
    city: "",
    content:
      "After i completed my CPA, i started viewing things differently. I feel like i'm understanding all the concepts. Study materials with miles is really good. Varun sirs videos are very well defined. The level of MCQs were similiar to the ones we got in the exam and took practice tests regularly.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Aayush_Gupta_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Aayush_Gupta_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Aayush%20Gupta.png",
    youtubeLink: "https://youtu.be/aA__FM08K8A?si=Exq9_S4fkWDH7y8Z",
  },
  // Rows 82-100 from the sheet (row 81 omitted, a duplicate). Image URLs
  // below follow the established ImageKit naming convention but the files
  // have not been uploaded yet - they will 404 until that upload happens.
  {
    name: "Anusha",
    course: "CPA",
    company: "",
    city: "Vizag",
    content:
      "Knowing that i am a CPA gives me a lot of confidence honestly and makes me independent. The best part about miles is that we have everything in one place and the LMS is very advantageous. Varun sirs videos really helped during my presentation.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anusha_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anusha_Video_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anusha.png",
    youtubeLink: "https://youtu.be/wT_qyvoJ4UA?si=ufsDMwrkqFQSX5hn",
  },
  {
    name: "Anas K P",
    course: "CPA",
    company: "KPMG",
    city: "",
    content:
      "Doing a CPA makes me feel confident in the industry that i'm working on. The best thing i like is the LMS facility they provide. We only need the LMS and Miles Textbook to crack it and video lecture can be useful as well for everyone.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anas_K_P_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anas_K_P_Video_Thumbnail.png ",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anas%20K%20P.png",
    youtubeLink: "https://youtu.be/DOUYIqEqFdY?si=qSUuz7AwJSLCvsFT",
  },
  {
    name: "Sachin Saxena",
    course: "CPA",
    company: "KPMG",
    city: "",
    content:
      "It is a renowned degree from USA which makes it have a high credit. It was a really exciting journey. The LMS, video lectures were a great expirience for me. By attempting the practice exam two times, it really helped to boost my confidence.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sachin_Saxena_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sachin_Saxena_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Sachin%20Saxena.png",
    youtubeLink: "https://youtu.be/UxJ9n36-LNg?si=JEMXnPvH9bxwklwX",
  },
  {
    name: "Keerthy P Kumar",
    course: "CPA",
    company: "KPMG",
    city: "Kerala",
    content:
      "I feel very secured with my career and i do not have to look back and think which builds a sense of confidence. It helped me grow and evolve personally. I find a better version of myself with a CPA tag. Overall journey with miles has been incredible. The quality of the material they provide is great.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Keerthy_P_Kumar_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Keerthy_P_Kumar_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Keerthy%20P%20Kumar.png",
    youtubeLink: "https://youtu.be/mj9b24CGnY8?si=wtTP5hBVticM51Rv",
  },
  {
    name: "Navya Yogesh",
    course: "CPA",
    company: "KPMG",
    city: "Bangalore",
    content:
      "I'm super happy with acheving the CPA tag along with my name. There's a definite change from before CPA to after CPA. I would really thank miles for guiding me right from the study materials to the teaching sessions.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Navya_Yogesh_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Navya_Yogesh_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Navya%20Yogesh.png",
    youtubeLink: "https://youtu.be/Pqbwf_BVgHw?si=rpA3ZdX8muaeSSV4",
  },
  {
    name: "Shishir",
    course: "CPA",
    company: "",
    city: "Bangalore",
    content:
      "Once i cleared CPA, the value regarding CPA outside was humongous. The level of respect increased. Miles was very supportive and Varun sirs teaching sessions holds a lot of value which actually made me sit in class and study.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shishir_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shishir_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shishir.png",
    youtubeLink: "https://youtu.be/cqLE8SkoPxA?si=rxH00ets84NTkymf",
  },
  {
    name: "Manasi",
    course: "CMA",
    company: "",
    city: "Mumbai",
    content:
      "CMA has become my way of living and as a professional i feel more confident. My journey with miles was great because i have got end to end support and the most exciting part was the kind of resources miles was providing.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Manasi_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Manasi_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Manasi.png",
    youtubeLink: "https://youtu.be/Zw1RCe05vKM?si=v4C9G8F8mO1bb7C0",
  },
  {
    name: "Yamini Ravi",
    course: "CMA",
    company: "",
    city: "",
    content:
      "After completing CMA, everyone views me as a valuable person and they give me a different kind of respect and i am very happy to be in that position. The journey with miles was great. I used the LMS and Varun sirs videos to help me to learn a lot about basics.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Yamini_Ravi_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Yamini_Ravi_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Yamini%20Ravi.png",
    youtubeLink: "https://youtu.be/Uj46OUDs2eU?si=5Qr5yklwgJ98j2N9",
  },
  {
    name: "Tannu Shri",
    course: "CMA",
    company: "",
    city: "Delhi",
    content:
      "After completing CMA, i am more confident, knowledgable and i am in my head to know what to do next. The miles team put a lot of efforts to make sure that we are comfortable and that is the best thing about them. The most important thing is to practice MCQs as much as possible.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Tannu_Shri_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Tannu_Shri_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Tannu%20Shri.png",
    youtubeLink: "https://youtu.be/O9hMvpnNVG8?si=um2RiAoBshomModP",
  },
  {
    name: "Nitisha D",
    course: "CMA",
    company: "",
    city: "Bangalore",
    content:
      "I have gained a lot of knowledge through my CMA course. Everything felt so complete from the start to the end and there is guidance for everything. LMS has a solution for each and everything. The way Varun sir explains the concepts in depth made us understand them easier.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nitisha_D_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nitisha_D_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Nitisha%20D.png",
    youtubeLink: "https://youtu.be/EbjD03HLx3M?si=w-VnauA71rh4S3kM",
  },
  {
    name: "Ganesh Bairi",
    course: "CMA",
    company: "",
    city: "Bangalore",
    content:
      "Miles is a 10 on 10 with the support you get before and after your exams. I did not go through anything other than the LMS and webinar videos and came back to the book which was very crisp and upto to the point.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Ganesh_Bairi_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Ganesh_Bairi_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Ganesh%20Bairi.png",
    youtubeLink: "https://youtu.be/lxaZ1ZFu4MI?si=39JW4GoX_LB0kZoj",
  },
  {
    name: "Muhammed Nazim",
    course: "CMA",
    company: "",
    city: "Kannur",
    content:
      "I would not be a CMA without Miles education today because miles has helped me a lot and it was beyond my expectation. Miles was there for everything and they were there to support me. The LMS has a very beginner friendly interface and the mock tests were a bit challenging than normal MCQs which made the exams less complex.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Muhammed_Nazim_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Muhammed_Nazim_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Muhammed%20Nazim.png",
    youtubeLink: "https://youtu.be/tT-5CoZWovE?si=MLr_Rg87Iq6hgW5h",
  },
  {
    name: "Shruti Pabbaraju",
    course: "CPA",
    company: "",
    city: "Bangalore",
    content:
      "I am defintely more confident after miles and CPA has fulfilled that and it really boosts your confidence and people do recognise you and give more importance than before. I thought CPA would be a great crediential to a profile.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shruti_Pabbaraju_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shruti_Pabbaraju_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Shruti%20Pabbaraju.png",
    youtubeLink: "https://youtu.be/oEI1KIJL73I?si=ddU1saTbK3J-vd8m",
  },
  {
    name: "Vriti Mehandiratta",
    course: "CPA",
    company: "",
    city: "Ahmedabad",
    content:
      "I feel very confident that i have such a professional degree with me. I have a great value that companies are ready to accept me. This course helped me align with my goals. They made each and every concept very easy to understand.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vriti_Mehandiratta_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vriti_Mehandiratta_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Vriti%20Mehandiratta.png",
    youtubeLink: "https://youtu.be/aU42KM6hdHk?si=sqVldboEA6qBa57Q",
  },
  {
    name: "Anant Mudit Tater",
    course: "CMA",
    company: "",
    city: "Gujarat",
    content:
      "This is definitely a change of course in the character of a person and i have seen myself go through that, from being a 12th grade graduate to being a CMA. It was really great journey with miles and they have helped me in all areas and their best feature in the LMS.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anant_Mudit_Tater_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anant_Mudit_Tater_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Anant%20Mudit%20Tater.png",
    youtubeLink: "https://youtu.be/Rjxhb-1cCGE?si=k1qWkNz9A_K7Dd5C",
  },
  {
    name: "Adil Raza",
    course: "CMA",
    company: "",
    city: "Kannur",
    content:
      "It was a really good experience from the lectures to the materials they give. These helped me prepare well and gain confidence. Varun sirs videos were really good and cleared my doubts.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Adil_Raza_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Adil_Raza_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Adil%20Raza.png",
    youtubeLink: "https://youtu.be/04gPgy7kSQk?si=lloQveMN9gEfbnRc",
  },
  {
    name: "Greeshma E",
    course: "CMA",
    company: "",
    city: "Kerala",
    content:
      "After i finished my CMA and went for an interview, the interviewer said that i was overqualified which made me so happy and felt proud about myself. I thought doing a CMA would be a great start for my career in Finance. Overall, miles and their teaching facilities are great.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Greeshma_E_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Greeshma_E_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Greeshma%20E.png",
    youtubeLink: "https://youtu.be/78YBoT3jiKM?si=ll_EPPDms3f7Ob5d",
  },
  {
    name: "Mohamed Ameen Nellikunnann",
    course: "CMA",
    company: "KPMG",
    city: "",
    content:
      "After completing CMA, everyone looks at me differently and gives respect. The materials provided by miles especially the books are great. Varun sirs classes and the mini mock test sessions really helped a lot and i gained more confidence.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Mohamed_Ameen_Nellikunnann_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Mohamed_Ameen_Nellikunnann_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Mohamed%20Ameen%20Nellikunnann.png",
    youtubeLink: "https://youtu.be/_ZlcPvHsodM?si=KgUiaLOB-3X34ccO",
  },
  {
    name: "Avanti Satish Barhate",
    course: "CMA",
    company: "",
    city: "Pune",
    content:
      "I have stepped from zero to one because of the CMA course so i am more knowledgable and confident now. LMS is the only shortcut i have on my google now because it is ready to use and is very convienent. It does not only contain MCQs, it also contains reading materials which really helps.",
    thumbnail:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Avanti_Satish_Barhate_Video_Thumbnail.png",
    videoPoster:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Avanti_Satish_Barhate_Thumbnail.png",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/alumni-data/Avanti%20Satish%20Barhate.png",
    youtubeLink: "https://youtu.be/DWpJbbuAqEo?si=p8FG7Dix4TX-RKHg",
  },
];

/**
 * Filter pills shown on the Career Success Stories page.
 * Sourced from the design; EA has no entries yet, so it renders an empty
 * state until stories are added.
 */
export const STORY_FILTERS = ["All", "CAIRA", "CPA", "CMA"] as const;

export type StoryFilter = (typeof STORY_FILTERS)[number];

export interface SuccessStory {
  /** Stable key. `videoId` repeats across entries, so index is folded in. */
  id: string;
  name: string;
  /** Raw label rendered in the badge, e.g. "CPA" or "CPA + CMA". */
  courseLabel: string;
  /** Normalised courses used for filtering; "CPA + CMA" matches both pills. */
  courses: string[];
  company: string;
  city: string;
  content: string;
  /** Video still for the story cards. */
  thumbnail: string;
  /**
   * Portrait frame the reel paints in place of the iframe - before playback
   * starts and whenever the video is paused - which is also what keeps
   * YouTube's own title chrome off screen. Kept separate from `thumbnail`
   * because that one is cropped for a card, not for a full-height reel.
   */
  videoPoster: string;
  /**
   * YouTube's own poster for the same video, used when an ImageKit image
   * fails to load, so the reel never renders as a black frame.
   */
  posterFallback: string;
  /** Headshot from the alumni-data folder; the reel caption avatar. */
  profilePic: string;
  videoId: string;
}

/**
 * Extracts the 11-character video id from the link shapes present in the data:
 *   "jP74L4ifaaY?si=..."                        (bare id)
 *   "https://youtu.be/HCCORwwQ5hU?si=..."       (short link)
 *   "https://youtube.com/shorts/6i5gRyWr-E4?si=..." (shorts)
 *   "https://www.youtube.com/watch?v=ID&..."    (watch link)
 */
export function getYouTubeId(link: string | undefined): string {
  if (!link) return "";

  const trimmed = link.trim();

  // watch?v=ID
  const watchMatch = trimmed.match(/[?&]v=([^&#]+)/);
  if (watchMatch) return watchMatch[1];

  // /shorts/ID, /embed/ID, youtu.be/ID
  const pathMatch = trimmed.match(/(?:shorts\/|embed\/|youtu\.be\/)([^/?&#]+)/);
  if (pathMatch) return pathMatch[1];

  // Bare id, optionally carrying a ?si= query string.
  if (!trimmed.includes("/")) return trimmed.split(/[?&#]/)[0];

  return "";
}

function normaliseCourses(course: string | undefined): string[] {
  if (!course) return [];
  return course
    .split(/[+/,&]/)
    .map((part) => part.trim().toUpperCase())
    .filter(Boolean);
}

/**
 * Adapts `alumniStories` into the shape the reels UI needs.
 * Entries without a resolvable video id are dropped so the player never
 * receives an empty id.
 */
export const successStories: SuccessStory[] = (alumniStories as any[])
  .map((item, index) => {
    const videoId = getYouTubeId(item.youtubeLink);
    return {
      id: `${videoId || "story"}-${index}`,
      name: item.name ?? "",
      courseLabel: item.course ?? "",
      courses: normaliseCourses(item.course),
      company: item.company ?? "",
      city: item.city ?? "",
      content: item.content ?? "",
      thumbnail: item.thumbnail ?? "",
      videoPoster: item.videoPoster || item.thumbnail || "",
      profilePic: item.profilePic ?? "",
      posterFallback: videoId
        ? `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`
        : "",
      videoId,
    };
  })
  .filter((story) => Boolean(story.videoId));

export function filterStories(
  stories: SuccessStory[],
  filter: StoryFilter,
): SuccessStory[] {
  if (filter === "All") return stories;
  return stories.filter((story) => story.courses.includes(filter));
}

/** "Grant Thornton | Gurgaon", collapsing gracefully when a field is missing. */
export function formatAffiliation(story: SuccessStory): string {
  return [story.company, story.city].filter(Boolean).join(" | ");
}

/**
 * Swaps a failed poster for `posterFallback`, once per element so a failing
 * fallback cannot loop.
 */
export function handlePosterError(
  event: React.SyntheticEvent<HTMLImageElement>,
  fallback: string,
): void {
  const img = event.currentTarget;
  if (!fallback || img.dataset.posterFallbackApplied) return;
  img.dataset.posterFallbackApplied = "true";
  img.src = fallback;
}
